"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorRichText = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useUpload_1 = __importDefault(require("@opsbase/react-gql-hooks/uploadfile/useUpload"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const react_simple_quill_1 = __importDefault(require("@opsbase/react-simple-quill"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = __importStar(require("react"));
const uuid = __importStar(require("uuid"));
const makeMyClasses = () => ({
    root: {
        '& em': {
            fontStyle: 'italic !important',
            color: 'black !important',
        },
        '& strong': {
            fontStyle: 'normal',
            fontWeight: 'bold',
        },
        '& .ql-toolbar.ql-snow': {
            borderColor: lib_palette_1.default.BorderGrey.main,
        },
        '& .ql-snow .ql-tooltip': {
            whiteSpace: 'normal',
        },
        '& .ql-container': {
            height: 200,
            backgroundColor: '#F4F5F9',
        },
    },
    hiddenVis: {
        visibility: 'hidden',
    },
    addFile: {
        padding: 0,
        marginLeft: 'auto',
        marginRight: 25,
    },
    smallSpinner: {
        size: 24,
    },
});
const toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ color: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
    ['link', 'image', 'video'],
];
const formats = [
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'color',
    'list',
    'bullet',
    'indent',
    'align',
    'link',
    'image',
    'video',
];
function QuestionEditorRichText(props) {
    var _a;
    const { config, onChange, disabled = false } = props;
    const { isAlt, language } = (0, useSysLang_1.default)();
    const richInfo = isAlt ? ((_a = config.richInfoAlt) === null || _a === void 0 ? void 0 : _a[language]) || config.richInfo : config.richInfo;
    const files = (0, react_1.useRef)([]);
    const fileInputElement = (0, react_1.useRef)();
    const html = (0, react_1.useRef)((richInfo === null || richInfo === void 0 ? void 0 : richInfo.html) ? richInfo.html : '');
    const delta = (0, react_1.useRef)((richInfo === null || richInfo === void 0 ? void 0 : richInfo.quillDeltaStr) ? JSON.parse(richInfo === null || richInfo === void 0 ? void 0 : richInfo.quillDeltaStr) : null);
    const quillRef = (0, react_1.useRef)();
    const reactQuillRef = (0, react_1.useRef)();
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const upload = (0, useUpload_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    (0, react_1.useEffect)(() => {
        attachQuillRefs();
    });
    (0, react_1.useEffect)(() => {
        html.current = (richInfo === null || richInfo === void 0 ? void 0 : richInfo.html) || '';
        delta.current = JSON.parse((richInfo === null || richInfo === void 0 ? void 0 : richInfo.quillDeltaStr) || 'null');
        forceUpdate();
    }, [forceUpdate, richInfo]);
    const saveNow = (0, react_1.useMemo)(() => {
        return (0, debounce_1.default)(() => {
            var _a, _b, _c;
            if (((_a = html.current) === null || _a === void 0 ? void 0 : _a.length) && !((_b = delta.current) === null || _b === void 0 ? void 0 : _b.length))
                return;
            // Fixed Quill issue, https://github.com/quilljs/quill/issues/1328
            if (html.current.length === 11 && html.current.includes('<p><br></p>')) {
                html.current = '';
            }
            const quillDeltaStr = ((_c = delta.current) === null || _c === void 0 ? void 0 : _c.length) ? JSON.stringify(delta.current) : '[]';
            const newRichInfo = {
                html: html.current,
                files: files.current,
                quillDeltaStr,
            };
            if (isAlt) {
                onChange(Object.assign(Object.assign({}, config), { richInfoAlt: Object.assign(Object.assign({}, (config.richInfoAlt || {})), { [language]: newRichInfo }) }));
            }
            else {
                onChange(Object.assign(Object.assign({}, config), { richInfo: newRichInfo }));
            }
        }, 500);
    }, [config, isAlt, language, onChange]);
    const handleRef = (0, react_1.useCallback)(el => (reactQuillRef.current = el), []);
    const imageHandler = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        let fileInput = fileInputElement.current;
        if (!fileInput) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.onclick = e => {
                const element = e.target;
                // setting files to null ensure onchange event triggers
                element.files = null;
            };
            fileInput.onchange = () => __awaiter(this, void 0, void 0, function* () {
                if (!!fileInput.files && !!fileInput.files[0]) {
                    const file = fileInput.files[0];
                    if (/^image\//.test(file.type)) {
                        const range = reactQuillRef.current.getEditor().getSelection(true);
                        const data = yield upload({
                            fileName: uuid.v4(),
                            userImage: file,
                        }, {
                            context: {
                                hasUpload: !!file, // activate Upload link
                            },
                        });
                        const link = `${data.url}?fullImage=true`;
                        if (link) {
                            reactQuillRef.current
                                .getEditor()
                                .insertEmbed(range.index, 'image', link);
                            // Move cursor to right side of image (easier to continue typing)
                            reactQuillRef.current.getEditor().setSelection(range.index + 1);
                            fileInput.files = null;
                        }
                    }
                    else {
                        fileInput.files = null;
                    }
                }
            });
        }
        fileInputElement.current = fileInput;
        fileInput.click();
    }), [upload]);
    const modules = (0, react_1.useMemo)(() => ({
        toolbar: {
            container: toolbarOptions,
            handlers: {
                image: imageHandler,
            },
        },
        clipboard: {
            matchVisual: false,
        },
    }), [imageHandler]);
    const attachQuillRefs = (0, react_1.useCallback)(() => {
        // Ensure React-Quill reference is available:
        if (typeof reactQuillRef.current.getEditor !== 'function')
            return;
        // Skip if Quill reference is defined:
        if (quillRef.current != null)
            return;
        const editor = reactQuillRef.current.getEditor();
        if (quillRef.current != null)
            quillRef.current = editor;
    }, []);
    const handleChange = (0, react_1.useCallback)((content, _, source, quill) => {
        const v = quill.getHTML();
        if (v !== (richInfo === null || richInfo === void 0 ? void 0 : richInfo.html)) {
            html.current = v;
            delta.current = quill.getContents();
            saveNow();
        }
    }, [richInfo, saveNow]);
    return (react_1.default.createElement(core_1.Grid, null,
        react_1.default.createElement(core_1.Grid, { item: true, style: { overflow: 'visible' }, className: "_quill" },
            react_1.default.createElement(react_simple_quill_1.default, { readOnly: disabled, className: myCss.root, ref: handleRef, modules: modules, value: html.current, formats: formats, onChange: handleChange }))));
}
exports.QuestionEditorRichText = QuestionEditorRichText;
exports.default = QuestionEditorRichText;
